 let definitions = {
    "comprobante": [
        {
            value: 11,
            name: "Factura C"
        },
        {
            value: 12,
            name: "Nota de Débito C"
        },
        {
            value: 13,
            name: "Nota de Crédito C"
        },
        {
            value: 15,
            name: "Recibos C"
        }
    ],
    "responsable": [
        {
            value: "consumidor-final",
            name: "Consumidor Final"
        },
        {
            value: "iva-responsable-inscripto",
            name: "IVA Responsable Inscripto"
        },
        {
            value: "iva-sujeto-exento",
            name: "IVA Sujeto Exento"
        },
        {
            value: "monotributista-social",
            name: "Monotributista Social"
        },
        {
            value: "responsable-monotributo",
            name: "Responsable Monotributo"
        }
    ],
    "formapago": [
        {
            value: "contado",
            name: "Contado"
        },
        {
            value: "cuenta-corriente",
            name: "Cuenta Corriente"
        },
        {
            value: "tarjeta-credito",
            name: "Tarjeta de Crédito"
        },
        {
            value: "tarjeta-debito",
            name: "Tarjeta de Débito"
        },
        {
            value: "transferencia-bancaria",
            name: "Transferencia Bancaria"
        },
        {
            value: "10-dias",
            name: "10 días"
        },
        {
            value: "15-dias",
            name: "15 días"
        },
        {
            value: "20-dias",
            name: "20 días"
        },
        {
            value: "30-dias",
            name: "30 días"
        },
        {
            value: "45-dias",
            name: "45 días"
        },
        {
            value: "60-dias",
            name: "60 días"
        },
        {
            value: "90-dias",
            name: "90 días"
        }
    ],
    "documento": [
        {
            value: 80,
            name: "CUIT"
        },
        {
            value: 96,
            name: "DNI"
        },
        {
            value: 94,
            name: "Pasaporte"
        },
        {
            value: 99,
            name: "No informa"
        }
    ],
    "moneda": [
        {
            value: "PES",
            name: "Pesos Argentinos"
        },
        {
            value: "DOL",
            name: "Dólar Estadounidense"
        },
        {
            value: "060",
            name: "Euro"
        },
        {
            value: "012",
            name: "Real"
        },
        {
            value: "031",
            name: "Peso Boliviano"
        },
        {
            value: "033",
            name: "Peso Chileno"
        },
        {
            value: "032",
            name: "Peso Colombiano"
        },
        {
            value: "023",
            name: "Bolívar Venezolano"
        },
        {
            value: "035",
            name: "Nuevo Sol Peruano"
        },
        {
            value: "010",
            name: "Pesos Mejicanos"
        },
        {
            value: "011",
            name: "Pesos Uruguayos"
        },
        {
            value: "029",
            name: "Guaraní"
        },
        {
            value: "046",
            name: "Libra Esterlina"
        },
        {
            value: "019",
            name: "Yens"
        },
        {
            value: "064",
            name: "Yuan"
        }
    ],
    "concepto": [
        {
            value: "1",
            name: "Productos"
        },
        {
            value: "2",
            name: "Servicios"
        },
        {
            value: "3",
            name: "Productos y Servicios"
        }
    ],
    "unidades": [
        {
            value: 0,
            name: ""
        },
        {
            value: 1,
            name: "kg"
        },
        {
            value: 2,
            name: "m"
        },
        {
            value: 3,
            name: "m2"
        },
        {
            value: 4,
            name: "m3"
        },
        {
            value: 5,
            name: "1000 kWh"
        },
        {
            value: 6,
            name: "l"
        },
        {
            value: 7,
            name: "unidades"
        },
        {
            value: 8,
            name: "pares"
        },
        {
            value: 9,
            name: "docenas"
        },
        {
            value: 10,
            name: "quilates"
        },
        {
            value: 11,
            name: "millares"
        },
        {
            value: 14,
            name: "g"
        },
        {
            value: 15,
            name: "mm"
        },
        {
            value: 16,
            name: "mm3"
        },
        {
            value: 17,
            name: "km"
        },
        {
            value: 18,
            name: "hl"
        },
        {
            value: 20,
            name: "cm"
        },
        {
            value: 25,
            name: "jgo. pqt. mazo naipes"
        },
        {
            value: 27,
            name: "cm3"
        },
        {
            value: 29,
            name: "tn"
        },
        {
            value: 30,
            name: "dam3"
        },
        {
            value: 31,
            name: "hm3"
        },
        {
            value: 32,
            name: "km3"
        },
        {
            value: 33,
            name: "ug"
        },
        {
            value: 34,
            name: "ng"
        },
        {
            value: 35,
            name: "pg"
        },
        {
            value: 41,
            name: "mg"
        },
        {
            value: 47,
            name: "mm"
        },
        {
            value: 48,
            name: "curie"
        },
        {
            value: 49,
            name: "milicurie"
        },
        {
            value: 50,
            name: "microcurie"
        },
        {
            value: 51,
            name: "uiacthor"
        },
        {
            value: 52,
            name: "muiacthor"
        },
        {
            value: 53,
            name: "kg base"
        },
        {
            value: 54,
            name: "gruesa"
        },
        {
            value: 61,
            name: "kg bruto"
        },
        {
            value: 62,
            name: "uiactant"
        },
        {
            value: 63,
            name: "muiactant"
        },
        {
            value: 64,
            name: "uiactig"
        },
        {
            value: 65,
            name: "muiactig"
        },
        {
            value: 66,
            name: "kg activo"
        },
        {
            value: 67,
            name: "gramo activo"
        },
        {
            value: 68,
            name: "gramo base"
        },
        {
            value: 96,
            name: "packs"
        },
        {
            value: 97,
            name: "hormas"
        },
        {
            value: 98,
            name: "otras unidades"
        },

    ],
    "status": [
        {
            value: "DRAFT",
            name: "Borrador",
            color: "grey"
        },
        {
            value: "PENDING_AFIP",
            name: "Pendiente AFIP",
            color: "blue"
        },
        {
            value: "EMITTED",
            name: "Emitida",
            color: "green"
        },
        {
            value: "CANCELED",
            name: "Cancelada",
            color: "yellow"
        },
        {
            value: "REJECTED",
            name: "Rechazada",
            color: "red"
        },{
            value: "QUEUED",
            name: "En cola",
            color: "blue"
        }],
        "provincia":[
            {   value: 'BUENOS AIRES',
                name: 'Buenos Aires' },

            {   value: 'CATAMARCA',
                name: 'Catamarca' },

            {   value: 'CHACO',
                name: 'Chaco' },

            {   value: 'CHUBUT',
                name: 'Chubut' },

            {   value: 'CIUDAD AUTONOMA DE BUENOS AIRES',
                name: 'CABA' },

            {   value: 'CORDOBA',
                name: 'Córdoba' },

            {   value: 'CORRIENTES',
                name: 'Corrientes' },

            {   value: 'ENTRE RIOS',
                name: 'Entre Ríos' },

            {   value: 'FORMOSA',
                name: 'Formosa' },

            {   value: 'JUJUY',
                name: 'Jujuy' },

            {   value: 'LA PAMPA',
                name: 'La Pampa' },

            {   value: 'LA RIOJA',
                name: 'La Rioja' },

            {   value: 'MENDOZA',
                name: 'Mendoza' },

            {   value: 'MISIONES',
                name: 'Misiones' },

            {   value: 'NEUQUEN',
                name: 'Neuquén' },

            {   value: 'RÍO NEGRO',
                name: 'Río Negro' },

            {   value: 'SALTA',
                name: 'Salta' },

            {   value: 'SAN JUAN',
                name: 'San Juan' },

            {   value: 'SAN LUIS',
                name: 'San Luis' },

            {   value: 'SANTA FE',
                name: 'Santa Fe' },

            {   value: 'SANTA CRUZ',
                name: 'Santa Cruz' },

            {   value: 'SANTIAGO DEL ESTERO',
                name: 'Sgo. del Estero' },

            {   value: 'TUCUMAN',
                name: 'Tucumán' },

            {   value: 'TIERRA DEL FUEGO',
                name: 'Tierra del Fuego' },

        ]


}

export default definitions
